import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import QuoteModal from "../home/components/QuoteModal";
import LocationHero from "./components/LocationHero";
import LocationServices from "./components/LocationServices";
import LocationWhyUs from "./components/LocationWhyUs";
import LocationFacilities from "./components/LocationFacilities";
import LocationFAQ from "./components/LocationFAQ";
import LocationReviews from "./components/LocationReviews";
import NotFound from "../NotFound";
import { locationPages, additionalLocationPages } from "../../mocks/locationData";
const allLocationPages = [...locationPages, ...additionalLocationPages];

export default function LocationPage() {
  const { slug } = useParams<{ slug: string }>();
  const [modalOpen, setModalOpen] = useState(false);

  const location = allLocationPages.find((l) => l.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!location) return <NotFound />;

  return (
    <main className="font-sans bg-white">
      <Navbar onBookNow={() => setModalOpen(true)} />
      <LocationHero location={location} onBookNow={() => setModalOpen(true)} />
      <LocationServices location={location} onBookNow={() => setModalOpen(true)} />
      <LocationWhyUs location={location} onBookNow={() => setModalOpen(true)} />
      <LocationFacilities location={location} />
      <LocationReviews location={location} />
      <LocationFAQ location={location} onBookNow={() => setModalOpen(true)} />
      <Footer />
      <QuoteModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

      {/* Mobile floating CTA */}
      <div className="fixed bottom-6 right-6 z-40 md:hidden">
        <button
          onClick={() => setModalOpen(true)}
          className="bg-cl-dark text-white font-bold px-6 py-3.5 rounded-full cursor-pointer whitespace-nowrap flex items-center gap-2 cartoon-btn"
        >
          <i className="ri-map-pin-2-line"></i>
          Book in {location.city}
        </button>
      </div>
    </main>
  );
}
